var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('div',{staticClass:"back_left",on:{"click":function($event){return _vm.$router.go(-1)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }